import React, { createContext, useState } from 'react';

const AlertContext = createContext({
  state: {
    open: false,
    content: () => {},
    title: '',
    handleSubmit: () => {}
  },
  updateState: () => {},
});

export const AlertProvider = ({ children }) => {
  const [currentState, setCurrentState] = useState({
    open: false,
    content: () => {},
    title: '',
    handleSubmit: () => {},
    hasHandler: false
  });

  const handleUpdateAlert = (title, content, onSubmit, hasHandler = false) => {
    const newState = {
      open: !currentState.open,
      content: content,
      handleSubmit: onSubmit,
      title: title,
      hasHandler: hasHandler
    };
    setCurrentState(newState);
  };

  return (
    <AlertContext.Provider
      value={{
        state: currentState,
        updateState: handleUpdateAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContext;
